import { publicIpv4 } from "public-ip";
import { useQuery } from "react-query";

export async function getIP() {
  return await publicIpv4();
}

export function useIP() {
  return useQuery(["IP"], getIP);
}
